"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SessionTagParser_1 = __importDefault(require("./SessionTagParser"));
var LoaderParamsTagParser = /** @class */ (function (_super) {
    __extends(LoaderParamsTagParser, _super);
    function LoaderParamsTagParser(cssSelector, sessionManager, coreLoaderParams) {
        var _this = _super.call(this, cssSelector, sessionManager) || this;
        _this.coreLoaderParams = coreLoaderParams;
        return _this;
    }
    /**
     * Gets all BPElementConfig from HTML elements
     */
    LoaderParamsTagParser.prototype.parse = function () {
        var _this = this;
        var elements = _super.prototype.parse.call(this);
        //Set loaderparams
        elements = elements.map(function (element) {
            element.appid = _this.coreLoaderParams.app_id;
            element.lang = _this.coreLoaderParams.lang;
            return element;
        });
        return elements;
    };
    return LoaderParamsTagParser;
}(SessionTagParser_1.default));
exports.default = LoaderParamsTagParser;
